
import { observable, action, runInAction, toJS } from 'mobx';
import defaultData, { recommend } from "./data";
import moment from 'moment';
import { message } from 'antd';
import _ from "lodash";



class store {
    @observable date = moment().subtract(1, 'month').format('YYYY');
    @observable data = [...defaultData];
    @observable loading = false;
    @observable saving = false;
    @observable recommend = [...recommend];

    @action
    getData = async (date) => {
        runInAction(() => {
            this.loading = true;
            this.data = [];
        });
        try {

            const year = moment(date).format('YYYY');
            const url = `/salesPersonnelInfo?year=${year}`;
            let json = await fetch(url, { credentials: 'include' });
            let res = await json.json();
            console.log(res.data)
            runInAction(() => {
                this.loading = false;
                this.recommend = res.data.recommend.length ? res.data.recommend : [...recommend];
                this.data = res.data.data.length ? res.data.data : [...defaultData]
            }); 
        } catch (error) {
            console.error(error);
            message.error('数据处理失败！');
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    @action
    onSave = async () => {
        let date = this.date;
        let data = toJS(this.data).map(x => ({ ...x, year: date }));
        let recommend = toJS(this.recommend).map(x => ({ ...x, year: date }));

        runInAction(() => { this.saving = true });
        try {
            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(data));
            dataFrom.append('recommend', JSON.stringify(recommend));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }
            let json = await fetch('/salesPersonnelSave', headres);
            let res = await json.json();

            if (res.status == 1) {
                message.success('保存成功！');
                if (!data[0].id || !recommend[0].id) {
                    this.getData(this.date);
                }
            } else {
                message.error(res.msg);
            }
            runInAction(() => { this.saving = false });
        } catch (error) {
            message.error('保存失败！');
            console.error(error);
            runInAction(() => { this.saving = false });
        }
    }
}

const Month = new store();

export default Month;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/salesPersonnelAssessment/store.js